import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiPlus, FiMoreHorizontal, FiUpload, FiDownload } from 'react-icons/fi';
import { FormGroup, FormControl, Dropdown } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
// import Loading from 'components/Loading';
import Layout from 'components/Layout';
import TransactionList from 'components/Transactions';
import TransactionEditModal from 'components/Transactions/TransactionEditModal';
import EmployeeSelectSearch from 'components/EmployeeSelectSearch/EmployeeSelectSearch';
import { showModal, hideModal, updateModalLoading } from 'actions/modalActions';
import { transactionsService, appService } from 'services';
import * as rulesActions from 'actions/rulesActions';
import Modal from 'components/Modal';
import { withTranslation } from 'react-i18next';

import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import {
	RELATIVE_DATE_PRESETS,
	computeRelativeDateRange,
	DATE_PRESET_CUSTOM,
} from 'utils/relativeDatePresets';

///transactions/:employee/:account@:transaction_rule/:start@:end

class Transactions extends Component {
	constructor(props) {
		super(props);

		const DATE_PRESET_STORAGE_KEY = 'transactions_datePreset';
		const storedPreset =
			localStorage.getItem(DATE_PRESET_STORAGE_KEY) || DATE_PRESET_CUSTOM;
		const hasDateParams =
			!!this.props.match.params.start && !!this.props.match.params.end;

		let presetDates = null;
		if (!hasDateParams && storedPreset && storedPreset !== DATE_PRESET_CUSTOM) {
			const range = computeRelativeDateRange(storedPreset, moment());
			if (range?.start && range?.end) {
				presetDates = {
					start: range.start.format('YYYY-MM-DD'),
					end: range.end.format('YYYY-MM-DD'),
				};
			}
		}

		const today = new Date();
		const startOfMonth = moment(today).startOf('month').format('YYYY-MM-DD');
		const endOfMonth = moment(today).endOf('month').format('YYYY-MM-DD');

		this.state = {
			filterEmployeeId: this.props.match.params.employee || '',
			filterAccountId: this.props.match.params.account || '',
			filterDayFrom:
				this.props.match.params.start || presetDates?.start || startOfMonth,
			filterDayTo: this.props.match.params.end || presetDates?.end || endOfMonth,
			filterType: '',
			focusedInput: null,
			datePreset: hasDateParams ? DATE_PRESET_CUSTOM : storedPreset,
			transactions: [],
			page: 0, // result pagination
			hasMore: true, // list has more results to fetch
		};

		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewTransactionModal = this.openNewTransactionModal.bind(this);
		this.getTransactions = this.getTransactions.bind(this);
		this.openExportModal = this.openExportModal.bind(this);
		this.employeeSelectFetchOptions = { enabled: true };
	}

	componentDidMount() {
		this.getTransactions();
		this.props.getSelectableAccounts();
	}

	fetchMoreData = () => {
		const { page } = this.state;
		this.setState(
			{
				page: page + 1,
			},
			() => {
				this.getTransactions();
			}
		);
	};

	async getTransactions() {
		const {
			transactions,
			filterEmployeeId,
			filterAccountId,
			filterDayFrom,
			filterDayTo,
			filterType,
			page,
		} = this.state;
		const response = await transactionsService.getAll(
			filterEmployeeId,
			filterAccountId,
			filterDayFrom,
			filterDayTo,
			filterType,
			page
		);
		//console.log(response);
		let new_transactions = response.data;

		if (page > 0) {
			new_transactions = transactions.concat(new_transactions);
		}

		// console.log(new_transactions);

		if (response.ok) {
			this.setState({
				transactions: new_transactions,
				hasMore: response.data.length > 0,
			});
		} else {
			this.setState({
				error: true,
			});
		}
	}

	handleChangeSearch = (event) => {
		// console.log(event);
		this.setState(
			{
				[event.target.id]: event.target.value,
				page: 0,
			},
			() => {
				this.getTransactions();
			}
		);
	};

	handleEmployeeFilterChange = (idOrNull) => {
		this.setState(
			{
				filterEmployeeId: idOrNull || '',
				page: 0,
			},
			() => {
				this.getTransactions();
			}
		);
	};

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate) startDate = startDate.format('YYYY-MM-DD');

		if (endDate) endDate = endDate.format('YYYY-MM-DD');

		this.setState(
			{
				page: 0, // reset pagination
				filterDayFrom: startDate,
				filterDayTo: endDate,
				datePreset: DATE_PRESET_CUSTOM,
			},
			() => {
				this.getTransactions();
			}
		);
	};

	handleDatePresetClick = (presetId) => {
		const nextPreset = presetId || DATE_PRESET_CUSTOM;
		localStorage.setItem('transactions_datePreset', nextPreset);

		if (nextPreset === DATE_PRESET_CUSTOM) {
			this.setState({ datePreset: nextPreset, focusedInput: null });
			return;
		}

		const range = computeRelativeDateRange(nextPreset, moment());
		if (!range?.start || !range?.end) {
			this.setState({ datePreset: nextPreset, focusedInput: null });
			return;
		}

		this.setState(
			{
				datePreset: nextPreset,
				focusedInput: null,
				page: 0,
				filterDayFrom: range.start.format('YYYY-MM-DD'),
				filterDayTo: range.end.format('YYYY-MM-DD'),
			},
			() => {
				this.getTransactions();
			}
		);
	};

	closeModal() {
		this.props.hideModal();
	}

	openNewTransactionModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('transactions.newTransaction'),
				style: { width: '420px' },
				content: (
					<TransactionEditModal
						getTransactions={this.getTransactions}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			'edit'
		);
	}

	// export transactions

	openExportModal(token) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('transactions.exportTitle'),
				style: { width: '400px' },
				confirmText: this.props.t('common.download'),
				loadingText: this.props.t('common.downloading'),
				message: this.props.t('transactions.exportSuccess'),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token);
				},
			},
			'confirm'
		);
	}

	async handleExport() {
		const {
			filterDayFrom,
			filterDayTo,
			filterEmployeeId,
			filterAccountId,
			filterType,
		} = this.state;
		const token = await transactionsService.exportList({
			day_from: filterDayFrom,
			day_to: filterDayTo,
			employee_id: filterEmployeeId,
			account_id: filterAccountId,
			type: filterType,
		});

		if (token.ok) {
			this.openExportModal(token.access_token);
		} else {
			this.openAlertModal(
				this.props.t('transactions.exportError'),
				this.props.t('transactions.exportErrorTitle')
			);
		}
	}

	async downloadExport(token) {
		//console.log(token);
		const response = await appService.getExported(token);
		// console.log(response);

		var url = window.URL.createObjectURL(response);
		var a = document.createElement('a');
		document.body.appendChild(a);
		a.href = url;
		a.download = 'transacciones.xlsx';
		a.click();

		this.props.updateModalLoading(false); // Cambiar a no cargando
		this.closeModal(); // cerrar modal de confirmación
	}

	getContent = () => {
		if (!this.state.transactions) {
			return 'Error cargando las transacciones';
		}

		return (
			<TransactionList
				getTransactions={this.getTransactions}
				transactions={this.state.transactions}
			/>
		);
	};

	render() {
		const { select_accounts } = this.props;

		const optionAccountList =
			select_accounts.length > 0 &&
			select_accounts.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		return (
			<>
				<Layout
					configSidebar={true}
					className="page-transactions"
					context="rules"
				>
					<div className="heading">
						<h1 className="title">{this.props.t('transactions.title')}</h1>

						<div className="heading-filters">
							<FormGroup
								className="form-group form-select-user"
								controlId="filterEmployeeId"
							>
								<EmployeeSelectSearch
									className="form-select-user"
									controlId="filterEmployeeId"
									multiple={false}
									value={this.state.filterEmployeeId || null}
									onChange={this.handleEmployeeFilterChange}
									fetchOptions={this.employeeSelectFetchOptions}
									placeholder={this.props.t('common.searchEmployee')}
									allLabel={this.props.t('transactions.allEmployees')}
								/>
							</FormGroup>

							<FormGroup
								className="form-group form-search"
								controlId="filterAccountId"
							>
								<FormControl
									type="text"
									placeholder="Buscar..."
									value={this.state.filterAccountId}
									onChange={this.handleChangeSearch}
									as="select"
								>
									<option value="">{this.props.t('transactions.filterByAccount')}</option>
									{optionAccountList}
								</FormControl>
							</FormGroup>
							<FormGroup
								className="form-group form-search"
								controlId="filterType"
							>
								<FormControl
									type="text"
									placeholder="Buscar..."
									value={this.state.filterType}
									onChange={this.handleChangeSearch}
									as="select"
								>
									<option value="">{this.props.t('transactions.filterByType')}</option>
									<option value="Contrato">{this.props.t('transactions.typeContract')}</option>
									<option value="Manual">{this.props.t('transactions.typeManual')}</option>
									<option value="Regla">{this.props.t('transactions.typeRule')}</option>
								</FormControl>
							</FormGroup>
							<DateRangePicker
								startDateId="filterDayFrom"
								endDateId="filterDayTo"
								startDate={
									this.state.filterDayFrom
										? moment(this.state.filterDayFrom)
										: null
								}
								endDate={
									this.state.filterDayTo ? moment(this.state.filterDayTo) : null
								}
								startDatePlaceholderText={this.props.t('common.periodStart')}
								endDatePlaceholderText={this.props.t('common.periodEnd')}
								onDatesChange={this.onDatesChange}
								focusedInput={this.state.focusedInput}
								hideKeyboardShortcutsPanel={true}
								isOutsideRange={() => false}
								minimumNights={0}
								calendarInfoPosition="before"
								renderCalendarInfo={() => (
									<div
										style={{
											padding: '6px 10px',
											width: 180,
											display: 'flex',
											flexDirection: 'column',
											gap: 6,
											alignItems: 'stretch',
											overflowY: 'auto',
										}}
									>
										{RELATIVE_DATE_PRESETS.map((preset) => {
											const isSelected = this.state.datePreset === preset.id;
											return (
												<button
													type="button"
													key={preset.id}
													onClick={() => this.handleDatePresetClick(preset.id)}
													style={{
														width: '100%',
														textAlign: 'left',
														background: isSelected ? '#5b5dff' : 'transparent',
														color: isSelected ? '#fff' : '#6b7280',
														border: 'none',
														padding: '8px 10px',
														borderRadius: 6,
														cursor: 'pointer',
														fontWeight: isSelected ? 700 : 600,
													}}
												>
													{this.props.t(preset.label)}
												</button>
											);
										})}
									</div>
								)}
								onFocusChange={(focusedInput) =>
									this.setState({ focusedInput })
								}
							/>
						</div>
						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t('transactions.createTransaction')}
								onClick={this.openNewTransactionModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>

							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() => this.handleExport()}
									>
										<FiUpload className="dropdown-icon" /> {this.props.t('transactions.exportToExcel')}
									</Dropdown.Item>

									<Dropdown.Item
										as="button"
										onClick={() =>
											this.props.history.push('/transactions/import')
										}
									>
										<FiDownload className="dropdown-icon" /> {this.props.t('transactions.importTransactions')}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					<InfiniteScroll
						dataLength={this.state.transactions.length}
						next={this.fetchMoreData}
						endMessage={
							this.state.transactions.length > 0 && (
								<p className="no-more-results">{this.props.t('transactions.noMoreResults')}</p>
							)
						}
						hasMore={this.state.hasMore}
						//loader={<Loading />}
					>
						{this.getContent()}
					</InfiniteScroll>
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.employeesReducer,
		...reducers.rulesReducer,
		loading: reducers.rulesReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
	getSelectableAccounts: () => dispatch(rulesActions.getSelectableAccounts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Transactions));
